export default __webpack_public_path__ + "static/media/IMG_0018.a8683166.JPG";